export default {
    path: "documents",
    meta: {
        title: "Documents",
    },
    component: () =>
        import(/* webpackChunkName: "Documents" */ "@/views/Documents.vue"),
    children: [
        {
            path: "",
            name: "documents_index",
            meta: {
                title: "Documents",
            },
            component: () =>
                import(
                    /* webpackChunkName: "DocumentPreview" */ "@/views/Documents/Index.vue"
                ),
        },
        {
            path: "preview/:uuid",
            name: "document_preview",
            meta: {
                breadcrumbs: ['documents_index'],
                title: "Document Preview",
            },
            component: () =>
                import(
                    /* webpackChunkName: "DocumentPreview" */ "@/views/Documents/Preview.vue"
                ),
        },
        {
            path: "preview/:uuid/edit",
            name: "document_edit",
            meta: {
                breadcrumbs: ['documents_index', 'document_preview'],
                title: "Document Edit",
                sideMenuComponent: () =>
                    import("@/components/DocumentGeneration/QuestionSteps.vue"),
            },
            component: () =>
                import(
                    /* webpackChunkName: "DocumentEdit" */ "@/views/Documents/Edit.vue"
                ),
        },
    ],
};
